module.exports = __webpack_public_path__ + "static/mobilescreen-29812e0a83fbb4cf1636c72170a015b9.webp";